import * as types from "../actions/types/payoneer.types";

const initialState = {
    accountStatus: null,
    accountStatusState: "idle",
    accountBalances: null,
    accountBalancesState: "idle",
    transactionHistory: null,
    transactionHistoryState: "idle",
    receivingAccounts: null,
    receivingAccountsState: "idle",
};

export const payoneerReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Payoneer account status
        case types.GET_PAYONEER_ACCOUNT_STATUS_INPROGRESS:
            return {
                ...state,
                accountStatusState: "loading",
            };
        case types.GET_PAYONEER_ACCOUNT_STATUS_SUCCESS:
            return {
                ...state,
                accountStatusState: "success",
                accountStatus: action.payload,
            };
        case types.GET_PAYONEER_ACCOUNT_STATUS_FAILURE:
            return {
                ...state,
                accountStatusState: "failed",
            };

        // Get Payoneer account balances
        case types.GET_PAYONEER_ACCOUNT_BALANCES_INPROGRESS:
            return {
                ...state,
                accountBalancesState: "loading",
            };
        case types.GET_PAYONEER_ACCOUNT_BALANCES_SUCCESS:
            return {
                ...state,
                accountBalances: action.payload,
                accountBalancesState: "success",
            };
        case types.GET_PAYONEER_ACCOUNT_BALANCES_FAILURE:
            return {
                ...state,
                accountBalancesState: "failed",
            };

        // Get Transaction History
        case types.GET_PAYONEER_TRANSACTION_HISTORY_INPROGRESS:
            return {
                ...state,
                transactionHistoryState: "loading",
            };
        case types.GET_PAYONEER_TRANSACTION_HISTORY_SUCCESS:
            return {
                ...state,
                transactionHistory: action.payload,
                transactionHistoryState: "success",
            };
        case types.GET_PAYONEER_TRANSACTION_HISTORY_FAILURE:
            return {
                ...state,
                transactionHistoryState: "failed",
            };

        // Get Receiving Accounts
        case types.GET_PAYONEER_RECEIVING_ACCOUNTS_INPROGRESS:
            return {
                ...state,
                receivingAccountsState: "loading",
            };
        case types.GET_PAYONEER_RECEIVING_ACCOUNTS_SUCCESS:
            return {
                ...state,
                receivingAccounts: action.payload,
                receivingAccountsState: "success",
            };
        case types.GET_PAYONEER_RECEIVING_ACCOUNTS_FAILURE:
            return {
                ...state,
                receivingAccountsState: "failed",
            };

        default:
            return state;
    }
};
